import { useExternalFormStore } from '@/stores/externalForm'
import type { RouteLocationNormalized } from 'vue-router'

const ExternalForm = () => import('@/views/externalForm/ExternalView.vue')
const Form = () => import('@/views/externalForm/ExternalViewForm.vue')
const Summary = () => import('@/views/externalForm/ExternalViewSummary.vue')
const Closed = () => import('@/views/externalForm/ExternalViewClosed.vue')

const externalFormGuard = async () => {
  const externalFormStore = useExternalFormStore()
  const childEditionCreateFormAccess = await externalFormStore.getChildEditionCreateFormAccess()

  if (childEditionCreateFormAccess) return true
  return { name: 'closedExternalForm' }
}

export default {
  path: '/zglaszam',
  component: ExternalForm,
  children: [
    {
      path: '',
      component: Form,
      name: 'externalForm',
      meta: {
        title: 'Formularz zgłoszeniowy'
      },
      beforeEnter: externalFormGuard
    },
    {
      path: 'podsumowanie',
      component: Summary,
      name: 'externalFormSummary',
      meta: {
        title: 'Formularz zgłoszeniowy'
      },
      beforeEnter: async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
        await externalFormGuard()
        if (from.name !== 'externalForm') return { name: 'externalForm' }
        else return true
      }
    },
    {
      path: '',
      component: Closed,
      name: 'closedExternalForm',
      meta: {
        title: 'Formularz zgłoszeniowy'
      }
    }
  ]
}
